import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";

const heroImg = "https://images.unsplash.com/photo-1522778119026-d647f0596c20?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NTN8MHwxfHNlYXJjaHwxfHxzb2NjZXIlMjBzdGFkaXVtJTIwbmlnaHR8ZW58MHx8fHwxNzgxMzQ1NDA1fDA&ixlib=rb-4.1.0&q=85";

export default function Login() {
  const { login, user } = useAuth();
  const [email, setEmail] = useState("admin@calciohub.ai");
  const [password, setPassword] = useState("Admin123!");
  const [loading, setLoading] = useState(false);
  const nav = useNavigate();

  React.useEffect(() => { if (user) nav("/", { replace: true }); }, [user, nav]);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(email, password);
      toast.success("Benvenuto!");
      nav("/", { replace: true });
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Errore di accesso");
    } finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen grid md:grid-cols-2 bg-slate-950">
      <div className="relative hidden md:block">
        <img src={heroImg} alt="" className="absolute inset-0 w-full h-full object-cover opacity-50" />
        <div className="absolute inset-0 bg-gradient-to-br from-slate-950/80 via-slate-950/70 to-blue-950/80" />
        <div className="relative h-full flex flex-col justify-between p-12 text-white">
          <div className="flex items-center gap-3">
            <div className="w-11 h-11 rounded-md bg-blue-600 flex items-center justify-center text-2xl">⚽</div>
            <div>
              <div className="font-extrabold text-xl leading-none">CalcioHub</div>
              <div className="text-[10px] tracking-[0.25em] text-blue-300 font-mono mt-1.5">AI · PLATFORM</div>
            </div>
          </div>
          <div>
            <h2 className="text-5xl font-extrabold tracking-tight leading-tight">Gestisci il tuo<br/>canale di calcio<br/>con l'<span className="text-blue-400">AI</span>.</h2>
            <p className="mt-6 text-slate-300 max-w-md">Automazioni, pubblicazione multicanale, AI assistant e analytics in un'unica dashboard.</p>
          </div>
          <div className="text-xs text-slate-500 font-mono">v1.0 · CalcioHub AI Platform</div>
        </div>
      </div>
      <div className="flex items-center justify-center p-8">
        <form onSubmit={submit} data-testid="login-form" className="w-full max-w-sm space-y-6">
          <div>
            <h1 className="text-3xl font-extrabold text-white tracking-tight">Accedi</h1>
            <p className="text-sm text-slate-400 mt-1">Inserisci le credenziali per continuare</p>
          </div>
          <div className="space-y-3">
            <div>
              <Label htmlFor="email" className="text-slate-300">Email</Label>
              <Input id="email" type="email" data-testid="login-email" value={email}
                onChange={(e) => setEmail(e.target.value)} required
                className="bg-slate-900 border-slate-800 mt-1.5 h-11 focus:border-blue-500" />
            </div>
            <div>
              <Label htmlFor="password" className="text-slate-300">Password</Label>
              <Input id="password" type="password" data-testid="login-password" value={password}
                onChange={(e) => setPassword(e.target.value)} required
                className="bg-slate-900 border-slate-800 mt-1.5 h-11 focus:border-blue-500" />
            </div>
          </div>
          <Button type="submit" disabled={loading} data-testid="login-submit"
            className="w-full h-11 bg-blue-600 hover:bg-blue-700 text-white font-semibold">
            {loading ? "Accesso in corso..." : "Accedi alla dashboard"}
          </Button>
          <div className="text-xs text-slate-500 border border-slate-800 rounded-md p-3 bg-slate-900/50">
            <div className="font-semibold text-slate-400 mb-1">Account demo:</div>
            <div className="font-mono">admin@calciohub.ai · Admin123!</div>
            <div className="font-mono">editor@calciohub.ai · Editor123!</div>
            <div className="font-mono">collab@calciohub.ai · Collab123!</div>
          </div>
        </form>
      </div>
    </div>
  );
}
